import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { ApiError } from '@interfaces/api/api.interface';

export const errorInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      console.log('Http error:', error);
      const message = error.error?.message ?? error.message ?? 'Unhandled error';
      const errorIntercepted: ApiError = { message, success: false, code: error.status };
      return throwError(() => errorIntercepted);
    })
  );
};
